import { render } from "./DistributorProducts.vue?vue&type=template&id=2bcabd84&scoped=true"
import script from "./DistributorProducts.vue?vue&type=script&lang=js"
export * from "./DistributorProducts.vue?vue&type=script&lang=js"

import "./DistributorProducts.vue?vue&type=style&index=0&id=2bcabd84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcabd84"]])

export default __exports__